import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { StartupService } from './services/startup.service';
import { StepService } from './services/step.service';
import { debounceTime } from 'rxjs/operators';
import { ThreeDService } from './services/three-d.service';
import { AppInsightsService } from './services/appinsights.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  sharedLinkVersion = false;
  step: number;
  hideUI = true;

  constructor(
    translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    private startupService: StartupService,
    public stepService: StepService,
    private threeDService: ThreeDService,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    appInsights: AppInsightsService //Do not remove, needed to init app insights
  ) {
    translate.setDefaultLang('nl');
    translate.use('nl');

    document.documentElement.style.setProperty(
      '--document-height',
      document.documentElement.clientHeight.toString() + 'px'
    );
  }

  ngOnInit() {
    this.threeDService.finishedBuilding$.subscribe(() => {
      this.threeDService.setZoom(5);
      Array.from(document.getElementsByClassName('hidden')).forEach((el: any) => {
        el.style.transition = 'opacity 1s 2s ease-in-out';
        el.style.opacity = '1';
      });
    });
    this.stepService.stepChange$.subscribe((step: number) => {
      this.step = step;
    });

    this.startupService.sharedLinkConfiguration$.subscribe((data: false | string) => {
      if (data === false) {
        this.sharedLinkVersion = false;
        return;
      }
      this.sharedLinkVersion = true;
    });

    this.activatedRoute.queryParamMap.pipe(debounceTime(100)).subscribe(queryMap => {
      this.startupService.initialized$.next(false);
      this.startupService.readInput(queryMap);
    });
  }

  hasToken(): boolean {
    return !!this.startupService.token;
  }
}
